
import { BarChart4, Zap, Briefcase, BrainCircuit } from "lucide-react";
import StatsCard from "./StatsCard";

const StatsSection = () => {
  const stats = [
    {
      icon: BarChart4,
      value: 95,
      suffix: "%",
      description: "See AI as future core to legal work",
      citation: {
        number: 1,
        link: "https://www.thomsonreuters.com/en/press-releases/2024/july/ai-set-to-save-professionals-12-hours-per-week-by-2029"
      },
      delay: 100
    },
    {
      icon: Zap,
      value: 79,
      suffix: "%",
      description: "Used AI in 2024\nvs 19% in 2023",
      citation: {
        number: 2,
        link: "https://www.clio.com/resources/legal-trends/2024-report/"
      },
      delay: 200
    },
    {
      icon: Briefcase,
      value: 100,
      suffix: "K+",
      description: "Saved annually per lawyer",
      citation: {
        number: 3,
        link: "https://www.thomsonreuters.com/en/press-releases/2024/july/ai-set-to-save-professionals-12-hours-per-week-by-2029"
      },
      delay: 300
    },
    {
      icon: BrainCircuit,
      value: 50,
      suffix: "+",
      description: "Documents analyzed per minute",
      citation: {
        number: 4,
        link: "https://www.speedlegal.io/post/ai-based-applications-for-the-legal-field-analyzed"
      },
      delay: 400
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
      {stats.map((stat, index) => (
        <StatsCard key={index} {...stat} />
      ))}
    </div>
  );
};

export default StatsSection;
